'use client';

import { useParams } from 'react-router-dom';
import ProfilePage from '../../components/profile-page';

/**
 * SPA 个人中心：`/:game/profile`，复用 ProfilePage。
 * 爬虫/未挂 SPA 时仍走 app/[game]/[route] 的 profile 分支。
 */
export default function SpaProfilePage() {
  const params = useParams();
  const gameKey = String(params.game || '');

  if (!gameKey) {
    return (
      <main className="spa-boot" role="alert">
        <h1>缺少游戏标识</h1>
        <p>
          <a href="/">返回首页</a>
        </p>
      </main>
    );
  }

  return <ProfilePage key={gameKey} gameKey={gameKey} />;
}
